import mushroom from "./mushroom.es6";

mushroom._defineAsyncResource({
  name: "medical_facility",
  actions: {
    findById: { clientCache: true },
    findMany: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {}
  },
  views: {}
});
mushroom._defineAsyncResource({
  name: "register_for_exam_config",
  actions: {
    findById: { clientCache: true },
    findMany: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {}
  },
  views: {}
});
mushroom._defineAsyncResource({
  name: "advisory_for_exam_config",
  actions: {
    findById: { clientCache: true },
    findMany: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {}
  },
  views: {}
});
mushroom._defineAsyncResource({
  name: "user",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {}
  },
  views: {}
});
mushroom._defineAsyncResource({
  name: "nguoi_dan",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {}
  },
  views: { layHoTenTheoSoThe: {} }
});
mushroom._defineAsyncResource({
  name: "hs4210",
  actions: { findMany: { clientCache: true } },
  views: {}
});
mushroom._defineAsyncResource({
  name: "dot_kham",
  actions: { findMany: { clientCache: true } },
  views: {}
});
mushroom._defineAsyncResource({ name: "ho_so_831", actions: {}, views: {} });
mushroom._defineAsyncResource({
  name: "version",
  actions: {
    findById: { clientCache: true },
    findMany: { clientCache: true },
    createOne: {},
    updatePartially: {}
  },
  views: {}
});
mushroom._defineAsyncResource({
  name: "survey",
  actions: {
    findMany: { clientCache: false },
    findById: { clientCache: false }
  },
  views: {}
});
mushroom._defineAsyncResource({
  name: "dang_ky_kham",
  actions: {
    findById: { clientCache: false },
    findMany: { clientCache: false },
    createOne: {},
    updatePartially: {}
  },
  views: {}
});
mushroom._defineAsyncResource({
  name: "doi_tuong_cach_ly",
  actions: {
    findById: { clientCache: true },
    findMany: { clientCache: true },
    createOne: {},
    updatePartially: {}
  },
  views: {}
});
mushroom._defineAsyncResource({
  name: "danh_muc_tin",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {}
  },
  views: {}
});
mushroom._defineAsyncResource({
  name: "tin_tuc",
  actions: {
    findMany: { clientCache: true },
    findById: { clientCache: true },
    createOne: {},
    updatePartially: {}
  },
  views: {}
});
mushroom._defineAsyncResource({
  name: "tinh",
  actions: { findMany: { clientCache: true } },
  views: {}
});
mushroom._defineAsyncResource({
  name: "huyen",
  actions: { findMany: { clientCache: true } },
  views: {}
});
mushroom._defineAsyncResource({
  name: "menu",
  actions: { findMany: { clientCache: true } },
  views: {}
});
mushroom._defineAsyncResource({
  name: "chat_rooms",
  actions: {
    findById: { clientCache: true },
    findMany: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {}
  },
  views: {}
});

mushroom._defineAsyncResource({
  name: "bac_sy",
  actions: {
    findById: { clientCache: true },
    findMany: { clientCache: true },
    createOne: {},
    updatePartially: {}
  },
  views: {}
});
mushroom._defineAsyncResource({
  name: "nhom_benh",
  actions: { findMany: { clientCache: true } },
  views: {}
});
mushroom._defineAsyncResource({
  name: "qa_type",
  actions: {
    findById: { clientCache: true },
    findMany: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {}
  },
  views: {}
});

mushroom._defineAsyncResource({
  name: "app",
  actions: {
    findById: { clientCache: true },
    findMany: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {}
  },
  views: {}
});

mushroom._defineAsyncResource({
  name: "app_config",
  actions: {
    findById: { clientCache: true },
    findMany: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {}
  },
  views: {}
});

mushroom._defineAsyncResource({
  name: "user_guide",
  actions: {
    findById: { clientCache: true },
    findMany: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {}
  },
  views: {}
});

mushroom._defineAsyncResource({
  name: "file",
  actions: {
    findById: { clientCache: true },
    findMany: { clientCache: true },
    createOne: {},
    updatePartially: {},
    deleteOne: {}
  },
  views: {}
});
function toQueryString(obj, path) {
  if (obj === null || obj === undefined || typeof obj == "function") return "";

  if (
    typeof obj == "string" ||
    typeof obj == "number" ||
    typeof obj == "boolean"
  )
    return obj;

  if (Array.isArray(obj))
    return obj
      .map(function(item) {
        return toQueryString(item, path);
      })
      .join(",");

  var arr = [];
  for (var m in obj) {
    if (!obj.hasOwnProperty(m)) continue;

    var key = (path ? path : "") + m;
    arr.push(key + "=" + toQueryString(obj[m], key));
  }
  return arr.join("&");
}

mushroom.dot_kham.requestOtpAsync = function(body, parameters) {
  var p = mushroom.__createAsyncRestFunction({
    resource: "dot_kham",
    method: "POST",
    blankBody: false,
    headers: {
      "X-HTTP-Method-Override": "requestOtp"
    },
    url:
      mushroom._fnGetRootApiUrl() +
      "dot_khams/requestOtp?" +
      toQueryString(parameters),
    connection: mushroom.dot_kham,
    name: "requestOtp"
  })(body);
  return p;
};

mushroom.dot_kham.validateOtpAsync = function(body, parameters) {
  var p = mushroom.__createAsyncRestFunction({
    resource: "dot_kham",
    method: "POST",
    blankBody: false,
    headers: {
      "X-HTTP-Method-Override": "validateOtp"
    },
    url:
      mushroom._fnGetRootApiUrl() +
      "dot_khams/validateOtp?" +
      toQueryString(parameters),
    connection: mushroom.dot_kham,
    name: "validateOtp"
  })(body);
  return p;
};

mushroom.ho_so_831.requestOtpAsync = function(body, parameters) {
  var p = mushroom.__createAsyncRestFunction({
    resource: "ho_so_831",
    method: "POST",
    blankBody: false,
    headers: {
      "X-HTTP-Method-Override": "requestOtp"
    },
    url:
      mushroom._fnGetRootApiUrl() +
      "ho_so_831s/requestOtp?" +
      toQueryString(parameters),
    connection: mushroom.ho_so_831,
    name: "requestOtp"
  })(body);
  return p;
};

mushroom.ho_so_831.validateOtpAsync = function(body, parameters) {
  var p = mushroom.__createAsyncRestFunction({
    resource: "ho_so_831",
    method: "POST",
    blankBody: false,
    headers: {
      "X-HTTP-Method-Override": "validateOtp"
    },
    url:
      mushroom._fnGetRootApiUrl() +
      "ho_so_831s/validateOtp?" +
      toQueryString(parameters),
    connection: mushroom.ho_so_831,
    name: "validateOtp"
  })(body);
  return p;
};

mushroom.dot_kham.get_chi_phi_by_id_dot_kham_chua_benhAsync = function(
  body,
  parameters
) {
  var p = mushroom.__createAsyncRestFunction({
    resource: "dot_kham",
    method: "GET",
    blankBody: true,
    headers: {
      "X-HTTP-Method-Override": "get_chi_phi_by_id_dot_kham_chua_benh"
    },
    url:
      mushroom._fnGetRootApiUrl() +
      "dot_khams/get_chi_phi_by_id_dot_kham_chua_benh?" +
      toQueryString(parameters),
    connection: mushroom.dot_kham,
    name: "get_chi_phi_by_id_dot_kham_chua_benh"
  })(body);
  return p;
};

mushroom.ho_so_831.get_ho_so_831Async = function(body, parameters) {
  var p = mushroom.__createAsyncRestFunction({
    resource: "ho_so_831",
    method: "GET",
    blankBody: true,
    headers: {
      "X-HTTP-Method-Override": "get_ho_so_831"
    },
    url:
      mushroom._fnGetRootApiUrl() +
      "ho_so_831s/get_ho_so_831?" +
      toQueryString(parameters),
    connection: mushroom.ho_so_831,
    name: "get_ho_so_831"
  })(body);
  return p;
};

mushroom.ho_so_831.get_phrAsync = function(body, parameters) {
  var p = mushroom.__createAsyncRestFunction({
    resource: "ho_so_831",
    method: "GET",
    blankBody: true,
    headers: {
      "X-HTTP-Method-Override": "get_phr_by_ma_dang_ky"
    },
    url:
      mushroom._fnGetRootApiUrl() +
      "ho_so_831s/get_phr_by_ma_dang_ky?" +
      toQueryString(parameters),
    connection: mushroom.ho_so_831,
    name: "get_phr_by_ma_dang_ky"
  })(body);
  return p;
};

mushroom.nguoi_dan.get_index_831Async = function(body, parameters) {
  var p = mushroom.__createAsyncRestFunction({
    resource: "nguoi_dan",
    method: "GET",
    blankBody: true,
    headers: {
      "X-HTTP-Method-Override": "get_index_831"
    },
    url:
      mushroom._fnGetRootApiUrl() +
      "nguoi_dans/get_index_831?" +
      toQueryString(parameters),
    connection: mushroom.nguoi_dan,
    name: "get_index_831"
  })(body);
  return p;
};

mushroom.nguoi_dan.getAllInForAsync = function(body, param) {
  return mushroom.__createAsyncRestFunction({
    name: "cospeopleimgtype.getviewcardcode",
    rootApiUrl: mushroom.$using(),
    method: "GET",
    blankBody: true,
    url:
      mushroom.$using() +
      "cospeopleimgtype/getviewcardcode?" +
      toQueryString(param)
  })(param);
};
// mushroom.nguoi_dan.getAllInForAsync = function(param) {
//   return mushroom.__createAsyncRestFunction({
//     name: 'cospeopleimgtype.getviewcardcode',
//     rootApiUrl: mushroom.$using(),
//     method: 'GET',
//     blankBody: true,
//     url:
//       mushroom.$using() +
//       'cospeopleimgtype/getviewcardcode?' +
//       toQueryString(param),
//   })(param);
// };

mushroom.dang_ky_kham.get_hospitalAsync = function(param) {
  return mushroom.__createAsyncRestFunction({
    name: "dang_ky_kham.get_hospital",
    rootApiUrl: mushroom.$using(),
    method: "GET",
    headers: {
      "X-HTTP-Method-Override": "get_hospital"
    },
    blankBody: true,
    url:
      mushroom.$using() + "dang_ky_khams/get_hospital?" + toQueryString(param)
  })();
};

mushroom.dang_ky_kham.get_roomAsync = function(param) {
  return mushroom.__createAsyncRestFunction({
    name: "dang_ky_kham.get_room",
    method: "GET",
    headers: {
      "X-HTTP-Method-Override": "get_room"
    },
    blankBody: true,
    url:
      mushroom._fnGetRootApiUrl() +
      "dang_ky_khams/get_room?" +
      toQueryString(param)
  })();
};

mushroom.dang_ky_kham.get_serviceAsync = function(param) {
  return mushroom.__createAsyncRestFunction({
    name: "dang_ky_kham.get_service",
    method: "GET",
    headers: {
      "X-HTTP-Method-Override": "get_service"
    },
    blankBody: true,
    url:
      mushroom._fnGetRootApiUrl() +
      "dang_ky_khams/get_service?" +
      toQueryString(param)
  })();
};

mushroom.dang_ky_kham.get_patient_typeAsync = function(param) {
  return mushroom.__createAsyncRestFunction({
    name: "dang_ky_kham.get_patient_type",
    method: "GET",
    headers: {
      "X-HTTP-Method-Override": "get_patient_type"
    },
    blankBody: true,
    url:
      mushroom._fnGetRootApiUrl() +
      "dang_ky_khams/get_patient_type?" +
      toQueryString(param)
  })();
};

mushroom.dang_ky_kham.registerAsync = function(param) {
  return mushroom.__createAsyncRestFunction({
    name: "dang_ky_kham.register",
    method: "POST",
    headers: {
      "X-HTTP-Method-Override": "register"
    },
    blankBody: false,
    url: mushroom._fnGetRootApiUrl() + "dang_ky_khams/register"
  })(param);
};

mushroom.survey.bieu_mau_1Async = function(body, param) {
  return mushroom.__createAsyncRestFunction({
    name: "survey.bieu_mau_1",
    method: "POST",
    headers: {
      "X-HTTP-Method-Override": "bieu_mau_1"
    },
    blankBody: false,
    url:
      mushroom._fnGetRootApiUrl() + "surveys/bieu_mau_1?" + toQueryString(param)
  })(body);
};

mushroom.survey.bieu_mau_2_3Async = function(body, param) {
  return mushroom.__createAsyncRestFunction({
    name: "survey.bieu_mau_2_3",
    method: "POST",
    headers: {
      "X-HTTP-Method-Override": "bieu_mau_2_3"
    },
    blankBody: false,
    url:
      mushroom._fnGetRootApiUrl() +
      "surveys/bieu_mau_2_3?" +
      toQueryString(param)
  })(body);
};

mushroom.doi_tuong_cach_ly.get_manyAsync = function(body, param) {
  return mushroom.__createAsyncRestFunction({
    name: "doi_tuong_cach_ly.get_many",
    method: "GET",
    headers: {
      "X-HTTP-Method-Override": "get_many"
    },
    blankBody: false,
    url:
      mushroom._fnGetRootApiUrl() +
      "doi_tuong_cach_lys/get_many?" +
      toQueryString(param)
  })(body);
};

mushroom.bac_sy.importExcelAsync = function(body) {
  var p = mushroom.__createAsyncRestFunction({
      resource: "bac_sy.import_excel",
      method: "POST",
      blankBody: false,
      headers: {
          "X-HTTP-Method-Override": "import_excel"
      },
      //rootApiUrl: rootApiUrl,
      url: mushroom._fnGetRootApiUrl() + "bac_sys/import_excel?",
      connection: mushroom.diem_den_an_toan,
      name: "import_excel",
      clearCache: true
  })(body);
  return p;
};

mushroom.tin_tuc.deleteAsync = function(body) {
  var p = mushroom.__createAsyncRestFunction({
      resource: "tin_tuc.delete",
      method: "POST",
      blankBody: false,
      headers: {
          "X-HTTP-Method-Override": "delete"
      },
      //rootApiUrl: rootApiUrl,
      url: mushroom._fnGetRootApiUrl() + "tin_tucs/delete?id=" + body.id,
      connection: mushroom.tin_tuc,
      name: "delete",
      clearCache: true
  })({});
  return p;
};

mushroom.bac_sy.deleteAsync = function(body) {
  var p = mushroom.__createAsyncRestFunction({
      resource: "bac_sy.delete",
      method: "POST",
      blankBody: false,
      headers: {
          "X-HTTP-Method-Override": "delete_doctor"
      },
      //rootApiUrl: rootApiUrl,
      url: mushroom._fnGetRootApiUrl() + "bac_sys/delete_doctor?id=" + body.id,
      connection: mushroom.bac_sy,
      name: "delete",
      clearCache: true
  })({});
  return p;
};

mushroom.register_for_exam_config.deleteAsync = function(body) {
  var p = mushroom.__createAsyncRestFunction({
      resource: "register_for_exam_config.delete",
      method: "POST",
      blankBody: false,
      headers: {
          "X-HTTP-Method-Override": "delete"
      },
      //rootApiUrl: rootApiUrl,
      url: mushroom._fnGetRootApiUrl() + "register_for_exam_configs/delete?id=" + body.id,
      connection: mushroom.register_for_exam_config,
      name: "delete",
      clearCache: true
  })({});
  return p;
};

mushroom.advisory_for_exam_config.deleteAsync = function(body) {
  var p = mushroom.__createAsyncRestFunction({
      resource: "advisory_for_exam_config.delete",
      method: "POST",
      blankBody: false,
      headers: {
          "X-HTTP-Method-Override": "delete"
      },
      //rootApiUrl: rootApiUrl,
      url: mushroom._fnGetRootApiUrl() + "advisory_for_exam_configs/delete?id=" + body.id,
      connection: mushroom.advisory_for_exam_config,
      name: "delete",
      clearCache: true
  })({});
  return p;
};

mushroom.version.deleteAsync = function(id) {
  var p = mushroom.__createAsyncRestFunction({
      resource: "tin_tuc.delete",
      method: "POST",
      blankBody: false,
      headers: {
          "X-HTTP-Method-Override": "delete"
      },
      //rootApiUrl: rootApiUrl,
      url: mushroom._fnGetRootApiUrl() + "versions/delete?id=" + id,
      connection: mushroom.tin_tuc,
      name: "delete",
      clearCache: true
  })({});
  return p;
};
mushroom.$using(window.MyConfig.hostApi);
export default mushroom;
